var channel = angular.module('channel', []).factory('channel', function() {
    let s = {
        observer: { },
    };
    // Registers a function to a specific id to listen on
    s.register = (id, cb) => {
        if (typeof(s.observer[id]) === 'undefined') {
            s.observer[id] = [];
        }
        s.observer[id].push(cb);
    };

    // Notifies all functions registered for specific id
    s.notify = (id, msg) => {
        if (typeof(s.observer[id]) !== 'undefined') {
			return Promise.all(
				s.observer[id].map(cb => cb(msg))
			);
        }
	};

	return s;
});

(function() {
    if (typeof define === 'function' && define.amd)
        define('channel', function () { return channel; });
    else if (typeof module !== 'undefined' && module.exports)
        module.exports = channel;
    else
        window.channel = channel;
})();
